export const PENDING_STATUS = 1;
export const SEEING_STATUS = 4;
export const LEFT_STATUS = 5;
export const DNA_STATUS = 6;
export const NEW_PENDING_STATUS = 2;
export const UNPAID_STATUS = 8;
export const CHECKED_STATUS = 2;
export const WAITING_FOR_UPLOAD  = 4;